import {
  Box, Typography,
} from '@mui/material';
import { FC } from 'react';
import {
  Controller, FieldErrors, Control,
} from 'react-hook-form';

import CustomDropdown from 'components/CustomDropdown';

import { InventoryArea } from 'types/customInventoryFilters.interface';
import { Option } from 'types/option.interface';
import { MoveInventoryFormData } from 'validation/inventorySchema';

interface AreaSelectorProps {
  areas: InventoryArea[];
   control: Control<MoveInventoryFormData>;
   errors: FieldErrors<MoveInventoryFormData>;
}

const AreaSelector: FC<AreaSelectorProps> = ({
  areas, control, errors,
}) => {
  const options: Option[] = areas.map(({ areaId, areaPath }) => ({
    key: areaId,
    value: areaPath,
  }));

  return (
    <>
      <Box display="flex" justifyContent="center" mb={2}>
        <Typography variant="h6" fontWeight={500}>Move Information</Typography>
      </Box>
      <Box display="flex" justifyContent="center" mb={2} gap={2} flexWrap="wrap">
        <Controller
          name="selectedArea"
          control={control}
          render={({ field }) => (
            <CustomDropdown
              sx={{ minWidth: 100 }}
              size="small"
              options={options}
              {...field}
              error={!!errors.selectedArea}
              helperText={errors.selectedArea?.message}
            />
          )}
        />
      </Box>
    </>
  );
};

export default AreaSelector;
